export default __webpack_public_path__ + "static/media/mc_screen_typing.a202c55f.svg";